import { render, staticRenderFns } from "./GiftCreatorPost.vue?vue&type=template&id=18bcfdc7&"
import script from "./GiftCreatorPost.vue?vue&type=script&lang=js&"
export * from "./GiftCreatorPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports